import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { Image, Text, View } from '@react-pdf/renderer';

import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { getImageSrc } from '@utils/fn';

interface EventLocationProps {
  event: PublicEventDetailsResponse;
}

const EventLocation = ({ event }: EventLocationProps) => {
  const { t } = useTranslation();

  return (
    <View style={globalStyles.body}>
      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor,
        }}
      >
        {'Event Location'}
      </Text>

      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor ?? 'black',
        }}
      />

      <View style={styles.locationWrapper}>
        <Text style={styles.icon}>{'\uf3c5'}</Text>
        <Text style={styles.location}>
          {event?.address?.street}, {event?.address?.postalCode}{' '}
          {event?.address?.city}, {t(`countries.${event?.address?.country}`)}
        </Text>
      </View>

      <Text style={styles.description}>{event.location?.description}</Text>

      <Image
        style={styles.image}
        src={
          (event?.location?.images as any)?.image_additional_one
            ? getImageSrc((event?.location?.images as any).image_additional_one)
            : 'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_event_location_1.png'
        }
      />

      <View style={styles.imageRow}>
        <Image
          style={{
            ...styles.thumbnail,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
          src={
            (event?.location?.images as any)?.image_additional_three
              ? getImageSrc(
                  (event?.location?.images as any).image_additional_three
                )
              : 'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_event_location_3.png'
          }
        />
        <Image
          style={{
            ...styles.thumbnail,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
          src={
            (event?.location?.images as any)?.image_additional_two
              ? getImageSrc(
                  (event?.location?.images as any).image_additional_two
                )
              : 'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_event_location_2.png'
          }
        />
      </View>
    </View>
  );
};

export default EventLocation;
